<template>
    <div id="menu-bar" class="w-full bg-grey-lightest shadow-lg flex flex-row justify-around items-center">
        <div class="flex-1">
            <router-link to="/Home">
                <img class="cursor-pointer ml-4" alt="Ed Budding Installatietechniek" src="/img/logo.png">
            </router-link>
        </div>
        <div class="flex-1">
            <div class="w-full flex flex-row justify-end">
                <ul class="list-reset mr-16 flex" v-for="page in pages">
                    <li class="mr-6">
                        <router-link class="el-li text-black hover:text-grey-dark" :to="page.route.to">
                            {{page.route.name}}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MenuBar",
        props: ['pages']
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');

    #menu-bar {
        height: 5rem;
        border-bottom: 3px solid #22292f;
    }

    .el-li {
        font-family: 'Source Sans Pro', sans-serif;
        font-size: x-large;
        text-transform: uppercase;
        padding: 5px;
        border-radius: 5px;
        transition: 200ms;
    }

    .el-li:hover {
        transition: 400ms;
        /*color: #fff;*/
        background: #eceef0;
    }

    img {
        display: block;
        max-width: 320px;
        max-height: 60px;
        width: auto;
        height: auto;
    }
</style>
